import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";

export type Product = {
  id: string;
  display_name: string;
};

export const useMissionProducts = () => {
  const privateAxios = usePrivateAxios();

  return useQuery<Product[]>({
    queryKey: ['missionProducts'],
    queryFn: async () => {
      const response = await privateAxios.get("/tmais/products");
      return response.data.data;
    }
  });
};
